export default __webpack_public_path__ + "static/media/dotcloud.f08142bb.svg";